<div class="product-quantity" data-test="product-quantity">
  @if (productQuantityControl?.invalid) {
    <div class="product-quantity__error notification notification-error text--input-small" data-test="product-quantity__input-error">
      <mat-icon>error</mat-icon>
      {{ productQuantityControl.errors?.['max'] ? productQuantityMaxErrorMessage : ('product.wizard.quantity.quantity-error' | translate) }}
    </div>
  }

  @if (quickChoiceItems?.length > 0) {
    <div class="product-quantity__quick-choice spacing--margin-bottom">
      <p class="text--bold">
        {{ 'product.wizard.quantity.chips-title' | translate }}
      </p>

      <agr-chips-filter
        class="product-quantity__quick-choice-chips"
        [formControl]="quickChoiceControl"
        [items]="quickChoiceItems"
        [multiple]="false"
        [hideClear]="true"
        [removable]="false"
        (change)="handleQuickChoiceChange($event)"
      ></agr-chips-filter>
      @if (isBulkProduct) {
        <a mat-button (click)="toggleShowMoreQuantityOptions()">
          {{ ((shouldShowAllChips$ | async) ? 'show_less' : 'show_more') | translate }}
        </a>
      }
    </div>
  }
  <br />
  <div class="product-quantity__form">
    <mat-form-field appearance="outline" class="product-quantity__input mat-form-field__no-spacing" data-test="product-quantity__input">
      <mat-label>{{ 'product.wizard.quantity.title' | translate }}</mat-label>
      <input
        #productQuantity
        matInput
        agrNumber
        [placeholder]="'product.wizard.quantity.title' | translate"
        [formControl]="productQuantityControl"
        class="product-quantity__input-text"
        data-test="product-quantity__input-text"
        (keydown.enter)="$event.preventDefault()"
      />
      <span matSuffix>
        {{ 'unit.' + quantityItem.orderingInformation.orderUnit | translate }}
      </span>
    </mat-form-field>
  </div>
  @if (quantityItem?.packagingInformation?.packageDescription || quantityItem?.orderingInformation?.palletOrderUnitQuantity) {
    <div class="flex--column product-quantity__additional-product-information">
      <p class="text--bold">
        {{ 'product.wizard.quantity.additional-product-information-title' | translate }}
      </p>

      @if (quantityItem?.packagingInformation?.packageDescription) {
        <div class="flex__child product-quantity__additional-product-information--package-description">
          <p class="text--small text--gray">
            {{ 'product.wizard.quantity.package-description' | translate }}
          </p>
          <p>{{ quantityItem.packagingInformation.packageDescription }}</p>
        </div>
      }

      @if (totalOrderedWeightInKg !== null) {
        <div class="flex__child product-quantity__additional-product-information--total-ordered-weight">
          <p class="text--small text--gray">
            {{ 'product.wizard.quantity.total-ordered-weight' | translate }}
          </p>
          <p>{{ totalOrderedWeightInKg | number: '1.2-2' }} {{ 'unit.KG' | translate }}</p>
        </div>
      }

      @if (quantityItem?.orderingInformation?.palletOrderUnitQuantity) {
        <div class="flex__child product-quantity__additional-product-information--pallet-order-unit-quantity">
          <p class="text--small text--gray">
            {{ 'product.wizard.quantity.pallet-order-unit-quantity' | translate }}
          </p>
          <p>{{ quantityItem.orderingInformation.palletOrderUnitQuantity }}</p>
        </div>
      }
    </div>
  }
</div>
